import { useMemo } from 'react'
import { css } from '@emotion/react'
import { useFormContext } from 'react-hook-form'
import * as Yup from 'yup'
import { FormItemFrame } from '@/components/FormItemFrame'
import { ErrorMessage } from '@/components/Input/ErrorMessage'
import { Select } from '@/components/Input/Select'
import { RequiredLabel } from '@/components/RequiredLabel'
import { SupplementText } from '@/components/SupplementText'
import { prefectures } from '@lifedot/constants/prefectures'
import { typography } from '@lifedot/styles/typography'
import { EventTracker } from '@lifedot/tracking'
import { mq } from '@lifedot/styles/mediaQuery'

const styles = {
  prefecture: css({
    width: '49%',
    [mq('sp')]: {
      width: '48%'
    }
  }),
  supplement: css({
    marginTop: 8
  })
}

export const hakajimaiPrefectureSchema = {
  hakajimai_prefecture_ids: Yup.string().required(
    '墓じまいするお墓の所在地を選択してください'
  )
}
const yupObject = Yup.object(hakajimaiPrefectureSchema)
type HakajimaiPrefectureFormValues = Yup.InferType<typeof yupObject>

const prefectureValues = Object.values(prefectures).map((value, index) => ({
  label: value,
  value: (index + 1).toString()
}))

export const HakajimaiPrefecture = () => {
  const { watch } = useFormContext<HakajimaiPrefectureFormValues>()
  const hakajimaiPrefectureIds = watch('hakajimai_prefecture_ids')
  const hakajimaiPrefectureIdsValid = useMemo(
    () =>
      hakajimaiPrefectureSchema.hakajimai_prefecture_ids.isValidSync(
        hakajimaiPrefectureIds
      ),
    [hakajimaiPrefectureIds]
  )

  return (
    <FormItemFrame
      title={
        <>
          <label css={typography.textL} htmlFor="hakajimai_prefecture_ids">
            <b>現在のお墓の所在地（都道府県）</b>
          </label>
          <RequiredLabel allInputted={hakajimaiPrefectureIdsValid} />
        </>
      }
    >
      <div css={styles.prefecture}>
        <EventTracker
          action="click"
          elementLabel="hakajimai_prefecture_ids"
          label="hakajimaiMovingOutPrefectureId"
        >
          <Select
            name="hakajimai_prefecture_ids"
            title="都道府県"
            values={prefectureValues}
            defaultOption="都道府県を選ぶ"
            id="hakajimai_prefecture_ids"
          />
        </EventTracker>
      </div>
      <ErrorMessage<HakajimaiPrefectureFormValues> name="hakajimai_prefecture_ids" />
      <div css={styles.supplement}>
        <SupplementText text="地域に沿った情報を送付いたします。" />
      </div>
    </FormItemFrame>
  )
}
